import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {SalesByHourReportModel} from "./sales-by-hour-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {
    EntityGroupByReportCriteriaComponent
} from "../../../reports/common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";

@Component({
    selector: "wbo-sales-by-hour-report",
    templateUrl: "./sales-by-hour-report.component.html",
    providers: [provideReportModel(SalesByHourReportModel)]
})
export class SalesByHourReportComponent extends AbstractReportPage {

    constructor(public model: SalesByHourReportModel) {
        super();
    }

    get showOutletOption(): boolean {
        return this.model.data.reportType !== EntityGroupByReportCriteriaComponent.OUTLET_VALUE;
    }
}
